import React, { useEffect } from 'react';
import LensAndReviews from '../../Pages/LensAndReviews/LensAndReviews.Page';
import { Navigate, Route, Routes } from 'react-router-dom';
import LensProfile from '../../Pages/LensProfile/LensProfile.Page';
import { useDispatch } from 'react-redux';
import { fetchStoreData } from '../../Features/lensSlice';
import { VideoContextProvider } from '../../Context/VideoContext';

function LensAndReviewsRoute() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchStoreData());
        // eslint-disable-next-line
    }, []);

    return (
        <Routes>
            <Route index 
                element={
                    <VideoContextProvider>
                        <LensAndReviews />
                    </VideoContextProvider>
                }
            />

            <Route path='profile'>
                <Route index element={<Navigate to='/lens-and-reviews' />} />

                <Route 
                    path=':lensId' 
                    element={
                        <LensProfile />
                    } 
                />
            </Route>
        </Routes>
    );
}

export default LensAndReviewsRoute;
